import React from "react";
import {uid} from "react-uid";
import ExperienceForm from "./experience_form";

function CareerForm(props) {
  const { user, career, onExperieceInputChange } = props;
  const experiences = career.experiences_attributes;

  return user.belonged_organization === true && (
    <React.Fragment>
      {experiences.map((experience, index) => {
        return (
          <ExperienceForm
            key={uid(experience, index)}
            index={index}
            experience={experience}
            onExperieceInputChange={onExperieceInputChange}
          />
        );
      })}
    </React.Fragment>
  );
}

export default CareerForm;
